import React, { useEffect, useRef, useState } from 'react'
import LeftBar from '../Components/LeftBar'
import Topbar from '../Components/Topbar'
import profDefault from '../Images/def.png'
import defaultCover from '../Images/coverbg.jpg'
import { useNavigate } from 'react-router-dom'
import BottomNav from '../Components/BottomNav'
import Form from "react-bootstrap/Form"
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from 'react-bootstrap'
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCamera } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faTiktok, faYoutube, faLinkedin, faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons"
import ProgressBar from 'react-bootstrap/ProgressBar';
import { app } from "../firebase.js"
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, updateDoc, getFirestore, getDoc, setDoc, deleteDoc } from "firebase/firestore";
import swal from 'sweetalert';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { Link } from 'react-router-dom'

function SocialSetup() {

    const [showInstagram, setShowInstagram] = useState(false)
    const [showTiktok, setShowTiktok] = useState(false)
    const [showYoutube, setShowYoutube] = useState(false)
    const [showTwitter, setShowTwitter] = useState(false)
    const [saveButton, setsaveButton] = useState(true);
    const [updateButton, setupdateButton] = useState(false);
    const [saveButton2, setsaveButton2] = useState(true);
    const [updateButton2, setupdateButton2] = useState(false);
    const [saveButton3, setsaveButton3] = useState(true);
    const [updateButton3, setupdateButton3] = useState(false);


    const [now, setNow] = useState(0);
    const [showProgress, setshowProgress] = useState();
    const db = getFirestore(app);
    const [userId, setUserId] = useState()
    const auth = getAuth();
    const navigate = useNavigate();

    const [profileImage, setProfileImage] = useState(profDefault);
    const [coverImage, setcoverImage] = useState(defaultCover)

    const [loggedInName, setloggedInName] = useState();
    const [loggedInemail, setloggedInemail] = useState();
    const [loggedIntheUsername, setloggedIntheUsername] = useState();

    const instaFollowersRef = useRef();
    const instaImpressionsRef = useRef();
    const instaEngagementRef = useRef();

    const tiktokFollowersRef = useRef();
    const tiktokImpressionsRef = useRef();
    const tiktokLikesRef = useRef();

    const youtubeSubsRef = useRef();
    const youtubeImpressionsRef = useRef();
    const youtubeAvgViewRef = useRef();

    const twitterFollowersRef = useRef();
    const twitterImpressionsRef = useRef();
    const twitterProfileViewsRef = useRef();

    //
    const nameRef = useRef();
    const phoneRef = useRef();
    const mpesaRef = useRef();
    const instagramRef = useRef();
    const tiktokRef = useRef();
    const youtubeRef = useRef();
    const twitterRef = useRef();
    const religiousRef = useRef();
    const politicalRef = useRef();
    const socialRef = useRef();
    const alcoholRef = useRef();
    const gamblingRef = useRef();
    const forexRef = useRef();
    const cryptoRef = useRef();
    const tradingRef = useRef();

    const [instagramURLValue, setinstagramURLValue] = useState();
    const [twitterURLValue, settwitterURLValue] = useState();
    const [tiktokURLValue, settiktokURLValue] = useState();
    const [youtubeURLValue, setyoutubeURLValue] = useState();

    // Switch states for DBC/CGC
    const [showInstaDBC, setShowInstaDBC] = useState(false);
    const [showInstaCGC, setShowInstaCGC] = useState(false);
    const [showTiktokDBC, setShowTiktokDBC] = useState(false);
    const [showTiktokCGC, setShowTiktokCGC] = useState(false);

    // Refs
    const instaDBCPostRef = useRef(null);
    const instaDBCStoryRef = useRef(null);
    const instaCGCDescRef = useRef(null);
    const instaCGCPriceRef = useRef(null);

    const tiktokDBCPostRef = useRef(null);
    const tiktokCGCDescRef = useRef(null);
    const tiktokCGCPriceRef = useRef(null);

    // YouTube
    const [showYoutubeDBC, setShowYoutubeDBC] = useState(false);
    const [showYoutubeCGC, setShowYoutubeCGC] = useState(false);
    const youtubeDBCPostRef = useRef();
    const youtubeCGCDescRef = useRef();
    const youtubeCGCPriceRef = useRef();

    // Twitter
    const [showTwitterDBC, setShowTwitterDBC] = useState(false);
    const [showTwitterCGC, setShowTwitterCGC] = useState(false);
    const twitterDBCPostRef = useRef();
    const twitterCGCDescRef = useRef();
    const twitterCGCPriceRef = useRef();

    const [currentUsername, setCurrentUsername] = useState('');



    const instaCGCDeliveryRef = useRef(null);
    const tiktokCGCDeliveryRef = useRef(null);
    const youtubeCGCDeliveryRef = useRef(null);
    const twitterCGCDeliveryRef = useRef(null);

    const [verifiedSocials, setVerifiedSocials] = useState({});
    const isVerified = (platform) =>
        verifiedSocials?.[platform]?.status === "verified";


    const [selectedPlatforms, setSelectedPlatforms] = useState({
        instagram: false,
        tiktok: false,
        youtube: false,
        twitter: false
    });

    const [servicePricing, setServicePricing] = useState({
        instagram: {
            directBrandContent: { post: 0, story: 0 },
            creatorGeneratedContent: { description: '', price: 0, deliveryTime: '' }
        },
        tiktok: {
            directBrandContent: { post: 0 },
            creatorGeneratedContent: { description: '', price: 0, deliveryTime: '' }
        },
        youtube: {
            creatorGeneratedContent: { description: '', price: 0, deliveryTime: '' }
        },
        twitter: {
            directBrandContent: { post: 0 },
            creatorGeneratedContent: { description: '', price: 0, deliveryTime: '' }
        }
    });

    const [socialStats, setSocialStats] = useState({
        instagram: { followers: 0, impressions: 0, engagement: 0 },
        tiktok: { followers: 0, impressions: 0, likes: 0 },
        youtube: { subscribers: 0, impressions: 0, avgViewDuration: 0 },
        twitter: { followers: 0, tweetImpressions: 0, profileViews: 0 }
    });

    const [currentStep, setCurrentStep] = useState(2); // assuming step 2 = Service Pricing
    const [saveStepButton, setSaveStepButton] = useState(true);
    const [savingStep, setSavingStep] = useState(false);


    //get the currently signed in user
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const uid = user.uid;
                setUserId(uid)
                const docRef = doc(db, "users", uid);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();

                    // basic info
                    setloggedInName(data.userName || "")
                    setloggedIntheUsername(data.theUsername || "")
                    setloggedInemail(data.email || "")
                    if (phoneRef.current) phoneRef.current.value = data.phoneNumber || ""
                    if (mpesaRef.current) mpesaRef.current.value = data.mpesaNumber || ""

                    // images
                    setProfileImage(data.profileImage || profDefault)
                    setcoverImage(data.coverImage || defaultCover)
                    setCurrentUsername(data.theUsername || "");

                    // ads not accepted checkboxes
                    if (data.adsNotAccepted) {
                        if (religiousRef.current) religiousRef.current.checked = data.adsNotAccepted.religious || false
                        if (politicalRef.current) politicalRef.current.checked = data.adsNotAccepted.political || false
                        if (socialRef.current) socialRef.current.checked = data.adsNotAccepted.socialIssues || false
                        if (alcoholRef.current) alcoholRef.current.checked = data.adsNotAccepted.alcohol || false
                        if (gamblingRef.current) gamblingRef.current.checked = data.adsNotAccepted.gambling || false
                        if (forexRef.current) forexRef.current.checked = data.adsNotAccepted.forex || false
                        if (cryptoRef.current) cryptoRef.current.checked = data.adsNotAccepted.crypto || false
                        if (tradingRef.current) tradingRef.current.checked = data.adsNotAccepted.trading || false
                    }

                    // social switches and URLs
                    if (data.socials) {
                        setShowInstagram(data.socials.instagram === "selected")
                        setShowTiktok(data.socials.tiktok === "selected")
                        setShowYoutube(data.socials.youtube === "selected")
                        setShowTwitter(data.socials.twitter === "selected")

                        setinstagramURLValue(data.instagramUrl)
                        settwitterURLValue(data.twitterUrl)
                        settiktokURLValue(data.tiktokUrl)
                        setyoutubeURLValue(data.youtubeUrl)


                        setSelectedPlatforms({
                            instagram: data.socials.instagram === "selected",
                            tiktok: data.socials.tiktok === "selected",
                            youtube: data.socials.youtube === "selected",
                            twitter: data.socials.twitter === "selected"
                        });
                    }


                    if (data.socialStats) {

                        setSocialStats(data.socialStats);
                        // Instagram
                        if (instaFollowersRef.current) instaFollowersRef.current.value = data.socialStats.instagram?.followers || 0;
                        if (instaImpressionsRef.current) instaImpressionsRef.current.value = data.socialStats.instagram?.impressions || 0;
                        if (instaEngagementRef.current) instaEngagementRef.current.value = data.socialStats.instagram?.engagement || 0;

                        // TikTok
                        if (tiktokFollowersRef.current) tiktokFollowersRef.current.value = data.socialStats.tiktok?.followers || 0;
                        if (tiktokImpressionsRef.current) tiktokImpressionsRef.current.value = data.socialStats.tiktok?.impressions || 0;
                        if (tiktokLikesRef.current) tiktokLikesRef.current.value = data.socialStats.tiktok?.likes || 0;

                        // YouTube
                        if (youtubeSubsRef.current) youtubeSubsRef.current.value = data.socialStats.youtube?.subscribers || 0;
                        if (youtubeImpressionsRef.current) youtubeImpressionsRef.current.value = data.socialStats.youtube?.impressions || 0;
                        if (youtubeAvgViewRef.current) youtubeAvgViewRef.current.value = data.socialStats.youtube?.avgViewDuration || 0;

                        // Twitter
                        if (twitterFollowersRef.current) twitterFollowersRef.current.value = data.socialStats.twitter?.followers || 0;
                        if (twitterImpressionsRef.current) twitterImpressionsRef.current.value = data.socialStats.twitter?.tweetImpressions || 0;
                        if (twitterProfileViewsRef.current) twitterProfileViewsRef.current.value = data.socialStats.twitter?.profileViews || 0;
                    }

                    if (data.servicePricing) {
                        setServicePricing(data.servicePricing);

                        // Set switches if prices exist
                        setShowInstaDBC(data.servicePricing.instagram?.directBrandContent?.post > 0 || false);
                        setShowInstaCGC(data.servicePricing.instagram?.creatorGeneratedContent?.price > 0 || false);

                        setShowTiktokDBC(data.servicePricing.tiktok?.directBrandContent?.post > 0 || false);
                        setShowTiktokCGC(data.servicePricing.tiktok?.creatorGeneratedContent?.price > 0 || false);

                        setShowYoutubeCGC(data.servicePricing.youtube?.creatorGeneratedContent?.price > 0 || false);

                        setShowTwitterDBC(data.servicePricing.twitter?.directBrandContent?.post > 0 || false);
                        setShowTwitterCGC(data.servicePricing.twitter?.creatorGeneratedContent?.price > 0 || false);
                    }


                    if (data.verifiedSocials) {
                        setVerifiedSocials(data.verifiedSocials);
                    }


                } else {
                    console.log("No such document!");
                }
            } else {
                navigate("/login");
            }
        });

        return () => unsubscribe();
    }, [navigate, auth]);



    function validateSocialStats() {
        if (showInstagram) {
            const igFollowers = Number(instaFollowersRef.current?.value || 0)
            if (igFollowers < 2000) {
                swal("Error", "Instagram requires at least 2,000 followers", "error")
                return false
            }
        }

        if (showTiktok) {
            const ttFollowers = Number(tiktokFollowersRef.current?.value || 0)
            if (ttFollowers < 1000) {
                swal("Error", "TikTok requires at least 1,000 followers", "error")
                return false
            }
        }

        if (showYoutube) {
            const ytSubs = Number(youtubeSubsRef.current?.value || 0)
            if (ytSubs < 500) {
                swal("Error", "YouTube requires at least 500 subscribers", "error")
                return false
            }
        }

        if (showTwitter) {
            const twFollowers = Number(twitterFollowersRef.current?.value || 0)
            if (twFollowers < 1000) {
                swal("Error", "Twitter X requires at least 1,000 followers", "error")
                return false
            }
        }

        return true
    }



    async function saveSocials() {
        if (!validateSocialStats()) return;
        setsaveButton2(false)
        setupdateButton2(true)

        const userRef = doc(db, "users", userId);
        const snap = await getDoc(userRef);
        const existingData = snap.data();

        const instagramInput = isVerified("instagram")
            ? existingData.instagramUrl
            : instagramRef.current?.value || "";

        const tiktokInput = isVerified("tiktok")
            ? existingData.tiktokUrl
            : tiktokRef.current?.value || "";

        const youtubeInput = isVerified("youtube")
            ? existingData.youtubeUrl
            : youtubeRef.current?.value || "";

        const twitterInput = isVerified("twitter")
            ? existingData.twitterUrl
            : twitterRef.current?.value || "";


        const socials = {
            instagram: showInstagram ? "selected" : "",
            tiktok: showTiktok ? "selected" : "",
            youtube: showYoutube ? "selected" : "",
            twitter: showTwitter ? "selected" : ""
        };

        const socialStats = {
            instagram: {
                followers: parseInt(instaFollowersRef.current?.value) || 0,
                impressions: parseInt(instaImpressionsRef.current?.value) || 0,
                engagement: parseInt(instaEngagementRef.current?.value) || 0
            },
            tiktok: {
                followers: parseInt(tiktokFollowersRef.current?.value) || 0,
                impressions: parseInt(tiktokImpressionsRef.current?.value) || 0,
                likes: parseInt(tiktokLikesRef.current?.value) || 0
            },
            youtube: {
                subscribers: parseInt(youtubeSubsRef.current?.value) || 0,
                impressions: parseInt(youtubeImpressionsRef.current?.value) || 0,
                avgViewDuration: parseInt(youtubeAvgViewRef.current?.value) || 0
            },
            twitter: {
                followers: parseInt(twitterFollowersRef.current?.value) || 0,
                tweetImpressions: parseInt(twitterImpressionsRef.current?.value) || 0,
                profileViews: parseInt(twitterProfileViewsRef.current?.value) || 0
            }
        };



        updateDoc(userRef, {
            instagramUrl: instagramInput,
            tiktokUrl: tiktokInput,
            youtubeUrl: youtubeInput,
            twitterUrl: twitterInput,
            socials: socials,
            socialStats: socialStats
        }).then(() => {
            setsaveButton2(true)
            setupdateButton2(false)
            swal("success", "updated successful", "success");
            window.location.reload();
        }).catch((err) => {
            setsaveButton2(true)
            setupdateButton2(false)
            console.error(err);
            swal("error", "update failed", "error");
        });
    }

    function saveServicePricing() {

        setsaveButton3(false)
        setupdateButton3(true)

        const userRef = doc(db, "users", userId);

        // Prepare pricing data
        const pricingData = {
            instagram: {
                directBrandContent: {
                    post: parseInt(instaDBCPostRef.current?.value) || 0,
                    story: parseInt(instaDBCStoryRef.current?.value) || 0
                },
                creatorGeneratedContent: {
                    description: instaCGCDescRef.current?.value || '',
                    price: parseInt(instaCGCPriceRef.current?.value) || 0,
                    deliveryTime: instaCGCDeliveryRef.current?.value || ''
                }
            },
            tiktok: {
                directBrandContent: {
                    post: parseInt(tiktokDBCPostRef.current?.value) || 0
                },
                creatorGeneratedContent: {
                    description: tiktokCGCDescRef.current?.value || '',
                    price: parseInt(tiktokCGCPriceRef.current?.value) || 0,
                    deliveryTime: tiktokCGCDeliveryRef.current?.value || ''
                }
            },
            youtube: {
                creatorGeneratedContent: {
                    description: youtubeCGCDescRef.current?.value || '',
                    price: parseInt(youtubeCGCPriceRef.current?.value) || 0,
                    deliveryTime: youtubeCGCDeliveryRef.current?.value || ''
                }
            },
            twitter: {
                directBrandContent: {
                    post: parseInt(twitterDBCPostRef.current?.value) || 0
                },
                creatorGeneratedContent: {
                    description: twitterCGCDescRef.current?.value || '',
                    price: parseInt(twitterCGCPriceRef.current?.value) || 0,
                    deliveryTime: twitterCGCDeliveryRef.current?.value || ''
                }
            }
        };

        // Save to Firestore
        updateDoc(userRef, {
            servicePricing: pricingData
        })
            .then(() => {
                setsaveButton3(true)
                setupdateButton3(false)
                swal("success", "Service pricing saved successfully", "success");
            })
            .catch((err) => {
                console.error(err);
                swal("error", "Failed to save service pricing", "error");
            });
    }

    const [showInstructionsModal, setShowInstructionsModal] = useState(false)

    const showInstructions = () => {
        setShowInstructionsModal(true)
    }

    const hideInstructions = () => {
        setShowInstructionsModal(false)
    }

    const handleSaveOnly = async () => {
        // Then save service pricing
        saveServicePricing();
        swal("Success", "Data saved successfully", "success");
    };

    const handleSaveAndNext = async () => {
        // Then save service pricing
        await saveServicePricing();
        // Then navigate to next component
        navigate("/subs-setup");
    };




    return (
        <div className='mainDashboard'>
            <div className="desktopOnly">
                <LeftBar />
            </div>

            <div className='mainContent'>
                <Topbar />

                <div className='editFormSection'>
                    <Form.Group className='mb-3'>
                        <Form.Label className='sectionTitle'>1. Social Accounts & Stats</Form.Label>
                        <div className='alert alert-primary mt-2 small'>
                            <p>Select the platforms you want to run ads on. Paste full URLs. Enter follower count, impressions, and engagement/likes.</p>
                        </div>

                        {/* Instagram */}
                        <div className='platformSwitch'>
                            <FontAwesomeIcon icon={faInstagram} className='platformIcon' />
                            <Form.Check
                                type='switch'
                                id='instaSwitch'
                                className='me-2'
                                checked={showInstagram}
                                onChange={() => setShowInstagram(!showInstagram)}
                            />
                            <Form.Label className='platformLabel'>Instagram</Form.Label>
                        </div>
                        {showInstagram && (
                            <div className='platformFields'>
                                <p className='platformFieldsPara'>You need at least 2,000 followers on instagram to be eligible</p>
                                <Form.Label>Instagram Username</Form.Label>
                                <Form.Control type='text' placeholder='Instagram Username' ref={instagramRef} defaultValue={instagramURLValue} disabled={isVerified("instagram")} className='formInput mt-1' />

                                <Form.Label>Followers</Form.Label>
                                <Form.Control type='number' placeholder='Followers' ref={instaFollowersRef} defaultValue={socialStats.instagram.followers} className='formInput mt-1' />

                                <Form.Label>Impressions/Views (last 1 month)</Form.Label>
                                <Form.Control type='number' placeholder='Impressions' ref={instaImpressionsRef} defaultValue={socialStats.instagram.impressions} className='formInput mt-1' />

                                <Form.Label>Engagement/Interactions (last 1 month)</Form.Label>
                                <Form.Control type='number' placeholder='Engagement' ref={instaEngagementRef} defaultValue={socialStats.instagram.engagement} className='formInput mt-1' />
                                <p className='platformFieldsPara2' onClick={showInstructions}>where do i get this data?</p>
                                {/* {!isVerified("instagram") && (
                                    <p
                                        className='verifySocialLink alert alert-info mt-2 small'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => navigate("/verify-account")}
                                    >
                                        Verify your instagram account
                                    </p>
                                )} */}
                            </div>
                        )}

                        {/* TikTok */}
                        <div className='platformSwitch mt-3'>
                            <FontAwesomeIcon icon={faTiktok} className='platformIcon' />
                            <Form.Check
                                type='switch'
                                id='tiktokSwitch'
                                className='me-2'
                                checked={showTiktok}
                                onChange={() => setShowTiktok(!showTiktok)}
                            />
                            <Form.Label className='platformLabel'>TikTok</Form.Label>
                        </div>
                        {showTiktok && (
                            <div className='platformFields'>
                                <p className='platformFieldsPara'>You need at least 1,000 followers on tiktok to be eligible</p>
                                <Form.Label>TikTok Username</Form.Label>
                                <Form.Control type='text' placeholder='TikTok Username' ref={tiktokRef} defaultValue={tiktokURLValue} disabled={isVerified("tiktok")} className='formInput mt-1' />

                                <Form.Label>Followers</Form.Label>
                                <Form.Control type='number' placeholder='Followers' ref={tiktokFollowersRef} defaultValue={socialStats.tiktok.followers} className='formInput mt-1' />

                                <Form.Label>Post Views (60 Days)</Form.Label>
                                <Form.Control type='number' placeholder='Video Impressions' ref={tiktokImpressionsRef} defaultValue={socialStats.tiktok.impressions} className='formInput mt-1' />

                                <Form.Label>Total Likes on profile</Form.Label>
                                <Form.Control type='number' placeholder='Total Likes' ref={tiktokLikesRef} defaultValue={socialStats.tiktok.likes} className='formInput mt-1' />
                                <p className='platformFieldsPara2' onClick={showInstructions}>where do i get this data?</p>
                                {/* {!isVerified("tiktok") && (
                                    <p
                                        className='verifySocialLink alert alert-info mt-2 small'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => navigate("/verify-account")}
                                    >
                                        Verify your tiktok account

                                    </p>
                                )} */}
                            </div>
                        )}

                        {/* YouTube */}
                        <div className='platformSwitch mt-3'>
                            <FontAwesomeIcon icon={faYoutube} className='platformIcon' />
                            <Form.Check
                                type='switch'
                                id='youtubeSwitch'
                                className='me-2'
                                checked={showYoutube}
                                onChange={() => setShowYoutube(!showYoutube)}
                            />
                            <Form.Label className='platformLabel'>YouTube</Form.Label>
                        </div>
                        {showYoutube && (
                            <div className='platformFields'>
                                <p className='platformFieldsPara'>You need at least 500 subscribers on Youtube to be eligible</p>
                                <Form.Label>YouTube Username</Form.Label>
                                <Form.Control type='text' placeholder='YouTube Username' ref={youtubeRef} defaultValue={youtubeURLValue} className='formInput mt-1' disabled={isVerified("youtube")} />

                                <Form.Label>Subscribers</Form.Label>
                                <Form.Control type='number' placeholder='Subscribers' ref={youtubeSubsRef} defaultValue={socialStats.youtube.subscribers} className='formInput mt-1' />

                                <Form.Label>Total Views (90 days) </Form.Label>
                                <Form.Control type='number' placeholder='Impressions' ref={youtubeImpressionsRef} defaultValue={socialStats.youtube.impressions} className='formInput mt-1' />

                                <Form.Label>Average Watch Time (90 days)</Form.Label>
                                <Form.Control type='number' placeholder='Avg View Duration' ref={youtubeAvgViewRef} defaultValue={socialStats.youtube.avgViewDuration} className='formInput mt-1' />
                                <p className='platformFieldsPara2' onClick={showInstructions}>where do i get this data?</p>
                                {/* {!isVerified("youtube") && (
                                    <p
                                        className='verifySocialLink alert alert-info mt-2 small'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => navigate("/verify-account")}
                                    >
                                        Verify your youtube account
                                    </p>
                                )} */}
                            </div>
                        )}

                        {/* Twitter/X */}
                        <div className='platformSwitch mt-3'>
                            <FontAwesomeIcon icon={faTwitter} className='platformIcon' />
                            <Form.Check
                                type='switch'
                                id='twitterSwitch'
                                className='me-2'
                                checked={showTwitter}
                                onChange={() => setShowTwitter(!showTwitter)}
                            />
                            <Form.Label className='platformLabel'>Twitter/X</Form.Label>
                        </div>
                        {showTwitter && (
                            <div className='platformFields'>
                                <p className='platformFieldsPara'>You need at least 1,000 followers on Twitter / X to be eligible</p>
                                <Form.Label>Twitter/X Username</Form.Label>
                                <Form.Control type='text' placeholder='Twitter Username' disabled={isVerified("twitter")} ref={twitterRef} defaultValue={twitterURLValue} className='formInput mt-1' />

                                <Form.Label>Followers</Form.Label>
                                <Form.Control type='number' placeholder='Followers' ref={twitterFollowersRef} defaultValue={socialStats.twitter.followers} className='formInput mt-1' />

                                <Form.Label>Tweet Impressions</Form.Label>
                                <Form.Control type='number' placeholder='Tweet Impressions' ref={twitterImpressionsRef} defaultValue={socialStats.twitter.tweetImpressions} className='formInput mt-1' />

                                <Form.Label>Profile Views</Form.Label>
                                <Form.Control type='number' placeholder='Profile Views' ref={twitterProfileViewsRef} defaultValue={socialStats.twitter.profileViews} className='formInput mt-1' />
                                <p className='platformFieldsPara2' onClick={showInstructions}>where do i get this data?</p>

                                {/* {!isVerified("twitter") && (
                                    <p
                                        className='verifySocialLink alert alert-info mt-2 small'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => navigate("/verify-account")}
                                    >
                                        Verify your Twitter account
                                    </p>
                                )} */}

                            </div>
                        )}

                    </Form.Group>

                    {saveButton2 &&
                        <button className='saveBtn mt-3' type='button' onClick={saveSocials}>Save Changes</button>
                    }

                    {updateButton2 &&
                        <button className='saveBtn mt-3' type='button'>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Updating changes...
                        </button>
                    }
                </div>

                <div className='editFormSection  mt-4 p-3'>
                    <Form.Group className='mb-3'>
                        <Form.Label className='sectionTitle'>2. Service Pricing</Form.Label>
                        <div className='alert alert-primary mt-2 small'>
                            <p>Set pricing for the selected platforms. You can enable/disable Direct Brand Content or Creator-Generated Content per platform.</p>
                        </div>

                        {/* Instagram */}
                        {selectedPlatforms.instagram && (
                            <div className='platformPricing mt-3 p-3 border rounded'>
                                <div className='d-flex align-items-center mb-3'>
                                    <FontAwesomeIcon icon={faInstagram} className='platformIcon' />
                                    <Form.Label className='platformLabel ms-2 mb-0'>Instagram</Form.Label>
                                </div>

                                {/* Direct Brand Content */}
                                <Form.Check
                                    type='switch'
                                    id='instaDBC'
                                    label='Direct Brand Content'
                                    checked={showInstaDBC}
                                    onChange={() => setShowInstaDBC(!showInstaDBC)}
                                />
                                {showInstaDBC && (
                                    <div className='mt-2 ms-4'>
                                        <Form.Label>Post Upload Price (KES)</Form.Label>
                                        <Form.Control type='number' ref={instaDBCPostRef} defaultValue={servicePricing.instagram.directBrandContent.post} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Story Upload Price (KES)</Form.Label>
                                        <Form.Control type='number' ref={instaDBCStoryRef} defaultValue={servicePricing.instagram.directBrandContent.story} className='formInput2 mt-1' />
                                    </div>
                                )}

                                {/* Creator-Generated Content */}
                                <Form.Check
                                    type='switch'
                                    id='instaCGC'
                                    label='Creator-Generated Content'
                                    checked={showInstaCGC}
                                    onChange={() => setShowInstaCGC(!showInstaCGC)}
                                    className='mt-3'
                                />
                                {showInstaCGC && (
                                    <div className='mt-2 ms-4'>
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control type='text' ref={instaCGCDescRef} defaultValue={servicePricing.instagram.creatorGeneratedContent.description} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Price (KES)</Form.Label>
                                        <Form.Control type='number' ref={instaCGCPriceRef} defaultValue={servicePricing.instagram.creatorGeneratedContent.price} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Delivery Time</Form.Label>
                                        <Form.Control
                                            type='text'
                                            placeholder='e.g. 3 days, 1 week'
                                            ref={instaCGCDeliveryRef}
                                            defaultValue={servicePricing.instagram.creatorGeneratedContent.deliveryTime}
                                            className='formInput2 mt-1'
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* TikTok */}
                        {selectedPlatforms.tiktok && (
                            <div className='platformPricing mt-3 p-3 border rounded'>
                                <div className='d-flex align-items-center mb-3'>
                                    <FontAwesomeIcon icon={faTiktok} className='platformIcon' />
                                    <Form.Label className='platformLabel ms-2 mb-0'>TikTok</Form.Label>
                                </div>

                                <Form.Check
                                    type='switch'
                                    id='tiktokDBC'
                                    label='Direct Brand Content'
                                    checked={showTiktokDBC}
                                    onChange={() => setShowTiktokDBC(!showTiktokDBC)}
                                />
                                {showTiktokDBC && (
                                    <div className='mt-2 ms-4'>
                                        <Form.Label>Post Upload Price (KES)</Form.Label>
                                        <Form.Control type='number' ref={tiktokDBCPostRef} defaultValue={servicePricing.tiktok.directBrandContent.post} className='formInput2 mt-1' />
                                    </div>
                                )}

                                <Form.Check
                                    type='switch'
                                    id='tiktokCGC'
                                    label='Creator-Generated Content'
                                    checked={showTiktokCGC}
                                    onChange={() => setShowTiktokCGC(!showTiktokCGC)}
                                    className='mt-3'
                                />
                                {showTiktokCGC && (
                                    <div className='mt-2 ms-4'>
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control type='text' ref={tiktokCGCDescRef} defaultValue={servicePricing.tiktok.creatorGeneratedContent.description} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Price (KES)</Form.Label>
                                        <Form.Control type='number' ref={tiktokCGCPriceRef} defaultValue={servicePricing.tiktok.creatorGeneratedContent.price} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Delivery Time</Form.Label>
                                        <Form.Control
                                            type='text'
                                            placeholder='e.g. 3 days, 1 week'
                                            ref={tiktokCGCDeliveryRef}
                                            defaultValue={servicePricing.tiktok.creatorGeneratedContent.deliveryTime}
                                            className='formInput2 mt-1'
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* YouTube */}
                        {selectedPlatforms.youtube && (
                            <div className='platformPricing mt-3 p-3 border rounded'>
                                <div className='d-flex align-items-center mb-3'>
                                    <FontAwesomeIcon icon={faYoutube} className='platformIcon' />
                                    <Form.Label className='platformLabel ms-2 mb-0'>YouTube</Form.Label>
                                </div>

                                <Form.Check
                                    type='switch'
                                    id='youtubeCGC'
                                    label='Creator-Generated Content'
                                    checked={showYoutubeCGC}
                                    onChange={() => setShowYoutubeCGC(!showYoutubeCGC)}
                                    className='mt-3'
                                />
                                {showYoutubeCGC && (
                                    <div className='mt-2 ms-4'>
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control type='text' ref={youtubeCGCDescRef} defaultValue={servicePricing.youtube.creatorGeneratedContent.description} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Price</Form.Label>
                                        <Form.Control type='number' ref={youtubeCGCPriceRef} defaultValue={servicePricing.youtube.creatorGeneratedContent.price} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Delivery Time</Form.Label>
                                        <Form.Control
                                            type='text'
                                            placeholder='e.g. 3 days, 1 week'
                                            ref={youtubeCGCDeliveryRef}
                                            defaultValue={servicePricing.youtube.creatorGeneratedContent.deliveryTime}
                                            className='formInput2 mt-1'
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Twitter */}
                        {selectedPlatforms.twitter && (
                            <div className='platformPricing mt-3 p-3 border rounded'>
                                <div className='d-flex align-items-center mb-3'>
                                    <FontAwesomeIcon icon={faTwitter} className='platformIcon' />
                                    <Form.Label className='platformLabel ms-2 mb-0'>Twitter/X</Form.Label>
                                </div>

                                <Form.Check
                                    type='switch'
                                    id='twitterDBC'
                                    label='Direct Brand Content'
                                    checked={showTwitterDBC}
                                    onChange={() => setShowTwitterDBC(!showTwitterDBC)}
                                />
                                {showTwitterDBC && (
                                    <div className='mt-2 ms-4'>
                                        <Form.Label>Tweet Upload Price</Form.Label>
                                        <Form.Control type='number' ref={twitterDBCPostRef} defaultValue={servicePricing.twitter.directBrandContent.post} className='formInput2 mt-1' />
                                    </div>
                                )}

                                <Form.Check
                                    type='switch'
                                    id='twitterCGC'
                                    label='Creator-Generated Content'
                                    checked={showTwitterCGC}
                                    onChange={() => setShowTwitterCGC(!showTwitterCGC)}
                                    className='mt-3'
                                />
                                {showTwitterCGC && (
                                    <div className='mt-2 ms-4'>
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control type='text' ref={twitterCGCDescRef} defaultValue={servicePricing.twitter.creatorGeneratedContent.description} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Price (KES)</Form.Label>
                                        <Form.Control type='number' ref={twitterCGCPriceRef} defaultValue={servicePricing.twitter.creatorGeneratedContent.price} className='formInput2 mt-1' />
                                        <Form.Label className='mt-2'>Delivery Time</Form.Label>
                                        <Form.Control
                                            type='text'
                                            placeholder='e.g. 3 days, 1 week'
                                            ref={twitterCGCDeliveryRef}
                                            defaultValue={servicePricing.twitter.creatorGeneratedContent.deliveryTime}
                                            className='formInput2 mt-1'
                                        />
                                    </div>
                                )}
                            </div>
                        )}

                        <div className='alert alert-primary mt-3 small'>
                            <p>Zindua App takes a 20 percent service fee from all ad submission earnings. The remaining 80 percent is paid to you after successful completion of the ad.</p>
                        </div>

                        {/* Save Button */}


                        <div className="formActions mt-3">
                            <button
                                type="button"
                                className="secondaryBtn"
                                onClick={() => navigate("/username-setup")} // previous page
                            >
                                Previous
                            </button>

                            {saveButton2 && (
                                <>
                                    <button
                                        type="button"
                                        className="saveBtn"
                                        onClick={handleSaveOnly} // just save
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        className="saveBtn"
                                        onClick={handleSaveAndNext} // save and move next
                                    >
                                        Save & Next
                                    </button>

                                </>
                            )}

                            {updateButton2 && (
                                <Button disabled className="primaryBtn">
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {" "}Saving...
                                </Button>
                            )}


                        </div>



                    </Form.Group>
                </div>
            </div>
            <div className="mobileOnly">
                <BottomNav />
            </div>

            <Modal
                show={showInstructionsModal}
                onHide={hideInstructions}
                centered
                size="lg">

                <Modal.Header closeButton>

                    <Modal.Title>Where to get your analytics data</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ fontSize: "14px" }}>
                        <p><strong>TikTok</strong></p>
                        <p>
                            Open TikTok. Go to Profile. Tap the menu on the top right.
                            Tap TikTok Studio. Tap Analytics.
                            Select Overview or Content.
                            Set date range to 60 days.
                        </p>

                        <p><strong>Instagram</strong></p>
                        <p>
                            Open Instagram. Go to Profile.
                            Tap the menu on the top right.
                            Tap Insights.
                            Open Accounts Reached or Engaged.
                            Set date range to 30 days.
                        </p>

                        <p><strong>YouTube</strong></p>
                        <p>
                            Go to studio.youtube.com.
                            Click Analytics.
                            Set date range to 90 days.
                            Use Views, Watch Time, and Subscribers.
                        </p>

                        <p><strong>Twitter X</strong></p>
                        <p>
                            Log in to x.com.
                            Click More on the left menu.
                            Click Analytics.
                            Open Account Home or Tweets.
                            Set date range to 28 or 90 days.
                        </p>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={hideInstructions}>
                        Close
                    </Button>
                </Modal.Footer>

            </Modal>
        </div>
    )
}

export default SocialSetup